import ContentSliderBlock from './blocks/ContentSliderBlock';
import ContentCarouselBlock from './blocks/ContentCarouselBlock';
import ContentGalleryBlock from './blocks/ContentGalleryBlock';
import ContentWindowBlock from './blocks/ContentWindowBlock';
import ContactFormOverlay from './components/ContactFormOverlay';

import '../styles/frontend.scss';

ContentSliderBlock.initializeAll();
ContentCarouselBlock.initializeAll();
ContentGalleryBlock.initializeAll();
ContentWindowBlock.initializeAll();
ContactFormOverlay.initializeAll();